export default {
  unableDelete:
    "该区域还有运营人员,请在管理员账号设置中移除再试!",
  today_recharge: "今日充值",
  sayExplain:'说明：此国家分区用于产品中的用户大区,主要区隔房间,用户和活动',
  day_cost: "今日流水",
  AreaName: "运营大区",

  // 国家管理
  countryManagement: {
    // country_management:'国家管理列表',
    country: "国家",
    country_management: "国家&区域",
    country_list: "国家列表",
    country_hot: "热门国家",
    country_add: "新增国家",
    country_id: "国家ID",
    country_name: "国家名称",
    country_flag: "国旗",
    country_number: "国家区号",
    country_room: "国家房间",
    country_region: "国家区域",
    country_code: "国家 code",
    country_details: "国家详情",
    country_details_hot: "热门国家详情",
    country_sort: "热门排序",
    country_isShow: "是否显示",
    country_area: "所在区域",
    country_edit: "编辑国家",
    country_delArea: "删除大区",
    // 国家分区tabs
    country_zone: "国家分区",
    country_zoneinfo: "国家分区详情",
    country_zone_add: "新增国家分区",
    country_zoneId: "分区ID",
    country_zoneName: "分区名称",
    country_zoneEnable: "是否启用",

    country_zonelocations: "列表位置",
    country_zoneOrder: "显示顺序",
    country_zoneWhet: "是否启用",
    country_inCountry: "区域包含国家",
    // 运营大区
    operationArea: "运营大区",
    operationArea_add: "新增运营大区",
    operationArea_id: "区域ID",
    operationArea_name: "区域名称",
    operationArea_manager: "区域负责人",
    operationArea_editManager: "编辑负责人",
    operationArea_addManager: "添加负责人",
    operationArea_addAreaManager: "编辑区域负责人",

    operationArea_accmanager: "该运营区域人员",
    operationArea_inCountry: "区域包含国家",
    operationArea_info: "运营区域详情",
    deletes: "删除",

    country_current: "当前国家",
    country_select: "选择国家",
    country_all: "全部",
    //
    language_en: "英语区", //country_region: 0
    language_en_ar: "英阿区", //country_region: 0
    language_ar: "阿语区", //country_region: 1
    language_tr: "土耳其语区", //country_region: 3
    language_hi: "印地语区", //country_region: 4
    language_vi: "越南区", //country_region: 5
    language_th: "泰国区", //country_region: 6
    language_es: "西语区", //country_region: 9
    language_in_id: "印尼区", //country_region: 10
    language_pt: "葡萄牙区", //country_region: 11
    language_india: "印度区" //country_region: 12
    //
  },
  //金币发放管理
  sendCoins: {
    send_coin_management: "金币发放管理",
    send_coin_management_list: "金币发放",
    send_tips:
      "注意：每次发放不能超过100个,单次金额不能超过5000000,每月每个人有金币数量和道具发放次数限制,由于分组发放，批量发放数量较大，采用分段发放模式，五分钟内发放完毕。",
    send_total: "历史总送出金币数量",
    send_time: "发放时间",
    send_operater: "金币发放者",
    send_coins_number: "发放金币数量",
    send_type: "发放类型",
    send_reason: "发放原因",
    send_coins: "发放金币",
    send_coins_batch: "批量金币发放",
    send_coins_group: "分组发放(未完成，缺少接口)",
    sendCard:'发放卡券',
    send_coins_prop: "发放道具",
    send_coins_propAll: "批量道具发放",
    send_medal_batch:'批量房间勋章发放',

    send_last_time: "最后发放时间",
    deduction_coins_batch: "批量扣除金币",
    record_id: "记录 ID",
    recipient: "金币获得者",
    recipient_id: "金币获得者 ID",
    user_no: "用户靓号 ID",
    give_coins: "赠送金币",
    file_note: "注意上传的文件类型是 '.xlsx'",
    confirm_distribution: "确定发放",
    select_file: "请选择文件",
    file_tip_no: "未选择文件",
    file_tip_yes: "已选文件",
    not_xlsx: "此文件非xlsx文件，请上传xlsx文件",
    download_template: "下载模板",
    enter_user_no: "请输入用户靓号",
    confirmation_deduction: "确认扣除",
    group_label: "组别",
    group_add: "新增组别",
    group_index: "序号",
    group_name: "组别名称",
    group_support_users: "扶持用户",
    group_dispense: "发放",
    group_edit: "修改",
    group_remove: "删除",

    tab5text1: "金币扣除者ID",
    tab5text2: "金币扣除者",
    tab5text3: "扣除金币数量",
    tab5text4: "扣除原因",
    tab5text5: "扣除操作者",
    type1: "系统充值(代充)",
    type2: "家族入驻",
    type3: "家族扶持",
    type4: "活动奖励",
    type5: "内部发放",
    type6: "其他奖励",
    type7: "",
    type8: "房间扶持",
    type9: "外管奖励",
    type10: "金币扶持",
    type23: "房间认证金币扶持",
    text1:
      "注意：每次发放不能超过200个,单次金额不能超过300000,每月每个人有金币数量和道具发放次数限制,由于分组发放，批量发放数量较大，采用分段发放模式，五分钟内发放完毕。"
  },
  //活动管理模块 -- 活动管理
  activity_management: {
    remark:'活动备注',
    ActivityManagement: "活动管理",
    activity_list: "常规活动",
    regular_activities: "常规活动",
    add_regular_activities: "添加常规活动",
    add_activity: "添加活动",
    edit_activity: "编辑活动",
    weekly_star: "周星活动",
    birthday_star: "生日之星",
    new_birthday_star: "新生日之星",
    statistical_region: "统计区域",
    activity_id: "活动ID",
    activity_title: "活动标题",
    activity_showPic: "活动展示图标",
    activity_region: "地区",
    activity_startTime: "开始时间",
    activity_endTime: "结束时间",
    activity_picture: "活动展示图标",
    activity_url: "活动URL",
    activity_type: "类型",
    activity_type_1: "水晶冲榜活动",
    activity_type_2: "个人冲榜活动",
    activity_type_3: "送礼物积分",
    activity_type_4: "普通跳转",
    activity_type_5: "一元夺宝",
    activity_type_6: "情人节冲榜",
    activity_type_7: "魅力冲榜活动",
    activity_type_8: "糖果节活动",
    activity_type_9: "许愿活动",
    activity_type_10: "房间pk活动",
    activity_type_11: "个人pk活动",
    activity_type_12: "家族pk活动",
    activity_type_13: "动物庄园",
    // activity_type_14:"cp认证",
    activity_type_15: "cp认证",
    activity_type_16: "战队冲榜",
    activity_type_17: "游戏跳转",
    activity_type_18: "许愿活动",
    activity_type_19: "战鼓pk",
    activity_type_21: "年度盛典",
    activity_type_23: "签到活动",
    activity_type_24: "花月活动",
    activity_type_25: "国家联赛",
    activity_type_26: "集卡活动",
    activity_type_27: "家族联赛",
    activity_type_28: "房间冲榜",
    activity_type_29: "美洲杯",
    activity_type_30: "爱情树",
    activity_type_31: "部落活动",
    activity_type_32: "越南国庆活动",
    activity_type_33: "球队比拼",
    activity_type_42: "球队比拼",
    activity_type_47: "西语区新用户派对活动",
    region_type_1: "全部",
    region_type_2: "英、阿地区",
    region_type_3: "土耳其区域",
    region_type_4: "印地地区",
    region_type_5: "越南地区",
    region_type_6: "泰语地区",
    region_type_9: "西语地区",
    region_type_10: "印尼地区",
    region_type_11: "葡萄牙地区",
    region_type_12: "印度",
    countryList: "国家榜单",
    gift_points: "积分礼物",
    //
    // 生日之星
    birth_time: "时间",
    birth_total_votes: "投票总数",
    birth_star_id: "生日之星ID",
    birth_star_votes: "生日之星票数",
    text1: "寿星ID",
    text2: "寿星票数",
    text3: "寿星最高积分",
    text4: "统计国家",
    text5: "黑名单",

    autoUrl:'生成活动链接',

    black_list_management:'黑名单管理',
  }
  //
};



// WEBPACK FOOTER //
// ./src/language/j-zh-cn.js